import { Capacitor } from "@capacitor/core";
import { TextZoom } from "@capacitor/text-zoom";

/** Apply the OS text size preference on native (initNative applies it again when the app comes back). */
export async function initFontSizeZoom(): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  const { value } = await TextZoom.getPreferred();
  /**
   * Cap the zoom between 100% and 125%. Values beyond 150% make the UI unusable since, in addition to scaling up the
   * text size, this also scales up the em/rem units used in our padding/margins/etc. Values below 100% can trigger
   * iOS auto-zoom behavior on text inputs.
   */
  document.documentElement.style.fontSize = `${Math.max(Math.min(value * 100, 125), 100)}%`;
}
